import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidatorService } from 'app/shared/services/validator.service';
import { ISelect } from 'app/shared/models/select.model';
import { IEmploymentHistoryItem } from 'app/shared/models/recruitment/employment-history-item.model';
import { Subject } from 'rxjs';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { MatRadioChange } from '@angular/material';
@Component({
    selector: 'app-modal-employment-history',
    styleUrls: ['./modal-employment-history.style.scss'],
    templateUrl: './modal-employment-history.template.html',
    encapsulation: ViewEncapsulation.None
  })

export class ModalEmploymentHistoryComponet implements OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
   /**Formularios */
  private formEmploymentHistory: FormGroup;
   /**Catalogos */
  private catalogReasonsOfExit: ISelect[];
  private listCatalogs = new Array() as Array<ISelect[]>;
   /**Retorno a pantalla padre */
  public onClose: Subject<IEmploymentHistoryItem>;
  /**Notificaciones */
  private configToast: any;
  /**Variables */
  private isCurrentJob: boolean;
  private employmentHistoryItem: IEmploymentHistoryItem;
  constructor(private bsModalRef: BsModalRef
    , private formBuilder: FormBuilder
    , configGeneral: AppConfig
    , public snotifyService: SnotifyService) {
      this.initializeFormEmploymentHistory();
      this.configToast = configGeneral.getConfigToast();
  }
  ngOnInit(): void {
    this.catalogReasonsOfExit = this.listCatalogs[0];
    this.onClose = new Subject();
    if (this.employmentHistoryItem === undefined) {
      this.employmentHistoryItem = {} as IEmploymentHistoryItem;
    } else {
      this.patchValueEmploymentHistoryItem(); 
    }
  }
  private patchValueEmploymentHistoryItem() {
    this.employmentHistoryItem.periodFrom = new Date(this.employmentHistoryItem.periodFrom);
    if(this.employmentHistoryItem.periodTo !== null) {
      this.employmentHistoryItem.periodTo = new Date(this.employmentHistoryItem.periodTo);
    }
    this.employmentHistoryItem.reasonOfExitId = this.employmentHistoryItem.reasonOfExitId.toString();
    this.formEmploymentHistory.patchValue(this.employmentHistoryItem);
    if (this.employmentHistoryItem.currentJob) {
      let x = {} as MatRadioChange;
      x.value = true;
      this.changeCurrentJob(x);
    }
  }
  private initializeFormEmploymentHistory() {
    this.formEmploymentHistory = this.formBuilder.group({
      companyName: [null, [Validators.required, Validators.maxLength(100)]],
      jobPosition: [null, [Validators.required, Validators.maxLength(100)]],
      periodFrom: [null, Validators.required],
      periodTo: [null, Validators.required],
      contact: [null, [Validators.required, Validators.maxLength(50)]],
      phone: [null, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      monthlySalary: [null, [Validators.required]],
      reasonOfExitId: [null, Validators.required],
      currentJob: [false, Validators.required]
    });
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
  save(): void {
    if (this.formEmploymentHistory.valid) {
      let data = {} as IEmploymentHistoryItem;
      data = this.mapEmploymentHistoryItem(this.formEmploymentHistory.value);
      this.onClose.next(data);
      this.bsModalRef.hide();
      } else {
        this.snotifyService.error('Capture toda la información requerida para poder continuar'
        , 'Validación', this.configToast);
      }
  }
  private changeCurrentJob($event: MatRadioChange) {
    this.isCurrentJob = $event.value;
    if (this.isCurrentJob) {
      this.formEmploymentHistory.get('periodTo').setValidators(null);
      this.formEmploymentHistory.get('periodTo').setValue(null);
    } else {
      this.formEmploymentHistory.get('periodTo').setValidators([Validators.required]);
    }
    this.formEmploymentHistory.get('periodTo').updateValueAndValidity();
  }
  private mapEmploymentHistoryItem(form: any): IEmploymentHistoryItem {
    const data = {} as IEmploymentHistoryItem;
    data.id = this.employmentHistoryItem.id == undefined ? 0 : this.employmentHistoryItem.id;
    data.monthlySalary = form.monthlySalary;
    data.companyName = form.companyName;
    data.jobPosition = form.jobPosition;
    data.periodFrom = form.periodFrom;
    data.periodTo = form.periodTo;
    data.contact = form.contact;
    data.phone = form.phone;
    data.reasonOfExitId = form.reasonOfExitId;
    data.currentJob = form.currentJob;
    data.reasonOfExit = this.catalogReasonsOfExit.filter(x => x.id === data.reasonOfExitId.toString())[0].text;
    return data;
  }
}
